
import {
    ItemDetailed,
    MaterialDetailed,
    IChargebackField,
    IMaintenanceRoSettleParams,
    IChargebackSearch,
    IChargebackDetail,
    IChargebackRoSettleAndWhConfirm,
    IChargebackList,
    IPrintExcel,
    IChargebackStatistics
} from "./chargebackType"
import { httpRequest } from "@/utils/HttpRequest";

class ChargebackService {
    async page(searchVo: IChargebackSearch) {
        const apiUrl = "/zzw-vrm/repair/return/findPage";
        return await httpRequest.post<IChargebackList>(apiUrl, searchVo);
    }
    async total(searchVo: IChargebackSearch) {
        const apiUrl = "/zzw-vrm/maintenance/total";
        return await httpRequest.post<IChargebackStatistics>(apiUrl, searchVo);
    }
    async one(id: string) {
        const apiUrl = `/zzw-vrm/repair/return/findById/${id}`;
        return await httpRequest.get<IChargebackDetail>(apiUrl);
    }
    async insert(insertVo: IChargebackField) {
        const apiUrl = "/zzw-vrm/maintenance/insert";
        return await httpRequest.post<IChargebackDetail>(apiUrl, insertVo);
    }
    async update(updateVo: IChargebackField) {
        const apiUrl = "/zzw-vrm/repair/return/update";
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
    //维修退单导出
    async export(params: IChargebackSearch) {
        const apiUrl = "/zzw-vrm/repair/return/export";
        return await httpRequest.postFile(apiUrl, params, { timeout: 300000 });
    }
    // 库房确认
    async warehousing(params: IChargebackRoSettleAndWhConfirm) {
        const apiUrl = "/zzw-vrm/repair/return/warehousing";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //结算
    async settl(params: IMaintenanceRoSettleParams) {
        const apiUrl = "/zzw-vrm/repair/return/settlePro";
        // const apiUrl = "/zzw-vrm/repair/return/settle";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //作废
    async invalidate(params: object) {
        const apiUrl = "/zzw-vrm/repair/return/invalidate";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //重新加载维修项目得数据
    async projectQuery(params: string[]) {
        const apiUrl = "/zzw-vrm/base/item/projectQuery";
        return await httpRequest.post<ItemDetailed[]>(apiUrl, params);
    }
    //重新加载维修用料得数据
    async find(params: string[]) {
        const apiUrl = "/zzw-vrm/stock/find";
        return await httpRequest.post<MaterialDetailed[]>(apiUrl, params);
    }
    //预约转维修
    async transfer(params: object) {
        const apiUrl = "/zzw-vrm/maintenance/transfer";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //转车间
    async tran(params: object) {
        const apiUrl = "/zzw-vrm/maintenance/tran";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //详情导出
    async detailsExport(params: IChargebackSearch) {
        const apiUrl = "/zzw-vrm/repair/return/repairFormExport";
        // const apiUrl = "/zzw-vrm/repair/return/detailsExport";
        return await httpRequest.postFile(apiUrl, params, { timeout: 300000 });
    }
    //打印Excel格式
    async excelPrint(params: IPrintExcel) {
        const apiUrl = "/zzw-vrm/maintenance/exportFind";
        return await httpRequest.postFile(apiUrl, params);
    }
    //打印预约单Excel格式
    async appointmentExcelPrint(params: IPrintExcel) {
        const apiUrl = "/zzw-vrm/appointment/exportFind";
        return await httpRequest.postFile(apiUrl, params);
    }
    //打印次数
    async printNum(id: string) {
        const apiUrl = `/zzw-vrm/repair/return/print/${id}`;
        return await httpRequest.get(apiUrl);
    }
    //审核接口
    async examine(params: object) {
        const apiUrl = `/zzw-vrm/maintenance/examine`;
        return await httpRequest.post(apiUrl, params);
    }
    //审核通过接口
    async approved(params: object) {
        const apiUrl = `/zzw-vrm/maintenance/approved`;
        return await httpRequest.post(apiUrl, params);
    }
}
export const chargebackService = new ChargebackService();
